import type { infer as zInfer } from "zod/v4";
import { boolean, object } from "zod/v4";

export const setShopifyRefundMethod = {
  name: "setShopifyRefundMethod" as const,
  input: object({ skipRefunds: boolean() }),
  output: object({ success: object({}).optional() }),
};

export type SetShopifyRefundMethodInput = zInfer<
  typeof setShopifyRefundMethod.input
>;
export type SetShopifyRefundMethodOutput = zInfer<
  typeof setShopifyRefundMethod.output
>;
